import { Tooltip } from 'chart.js';
import React from 'react';
import {Bar} from 'react-chartjs-2';
import { IsEmptyValue } from '../../helpers';
//import {Chart} from 'chart.js/auto'
//import { Button } from 'react-bootstrap';


export default class App extends React.Component {
  render() {
    console.log(this.props.datos);
    const state = {
      labels: this.props.datos.labels,
      datasets: [
        {
          label: 'P. Totales',
          backgroundColor: 'rgba(91,192,222)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.totales
        },
        {
          label: 'P. Recibidos',
          backgroundColor: 'rgba(240,173,78)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.recibidos
        },
        {
          label: 'P. Delivery',
          backgroundColor: 'rgba(51, 153, 255)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.delivery
        },
        {
          label: 'P. En ruta',
          backgroundColor: 'rgba(255, 102, 0)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.en_ruta
        },
        {
          label: 'P. En Preparación',
          backgroundColor: 'rgba(187,33,36)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.en_preparacion
        },
        {
          label: 'P. Entregados',
          backgroundColor: 'rgba(34,187,51)',
          borderColor: 'black',
          borderWidth: 1,
          data: this.props.datos.entregados
        }
      ]
    }

    const customTooltips = function (tooltip) {
      console.log(tooltip)
      if (!tooltip) {
        return;
      }
      // Tooltip Element
      let tooltipEl = document.getElementById("chartjs-tooltip");
    
      if (!tooltipEl) {
        tooltipEl = document.createElement("div");
        tooltipEl.id = "chartjs-tooltip";
        document.body.appendChild(tooltipEl);
      }
    
      // Set caret Position
      tooltipEl.classList.remove("above", "below", "no-transform");
      if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign);
      } else {
        tooltipEl.classList.add("no-transform");
      }
      const getBody = (bodyItem) => bodyItem.lines;
    
      //Hide the tooltips when mouseout
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }
    
      // Set custom tooltip
      if (tooltip.body) {
        const bodyLines = tooltip.body.map(getBody);
        const tooltipData = bodyLines[0][0];
    
        let innerHtml = "<div class='arrow_box'><ul>";
        const tooltipTitle = `<li key="title" class="tooltip-title">${tooltipData.labels} days</li>`;
        const tooltipValue = IsEmptyValue(
          tooltipData
        );
        const tooltipFooter = `<li key="footer" class="tooltip-footer"></li>`;
        innerHtml += tooltipTitle;
        innerHtml += "</ul></div>";
    
        // Set inner html to tooltip
        tooltipEl.innerHTML = innerHtml;
        var chartElement = this._chart.canvas.getBoundingClientRect();
        // Calculate position
        const positionY = chartElement.top + tooltip.yPadding;
        const positionX = chartElement.left + tooltip.xPadding;
        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1;
        tooltipEl.style.left = positionX + tooltip.caretX + "px";
        tooltipEl.style.top = positionY + tooltip.caretY + 10 + "px";
      }
    };

    return (
      <div style ={{width : '100%'}}>
        <Bar
          data={state}
          style ={{width : '100%'}}
          options={{
            plugins: {
              datalabels: {
                display: true,
                color: '#FF0000',
              }
            },
            legend:{
              display:true,
              position:'right'
            },
            interaction: {
              intersect: false,
              mode: 'index',
            },
            onClick: (e, elements) => {
              
              this.props.mostrarPedidosDeGrafica(elements[0].datasetIndex,elements[0].index)
              
 
            },
          }}
        />
      </div>
    );
  }
  
}
